export default __webpack_public_path__ + "static/realWorldBg-2c84454438817af050e03a340c5e8071.png";